import React from 'react';
import { observer } from 'mobx-react';
import { Chip, Typography } from '@execonline-inc/execonline-ui';

interface Props {
  children: React.ReactElement;
  ariaLabel?: string;
}

function ExperienceOverviewChip({ children, ariaLabel }: Props) {
  return (
    <Chip
      variant="solid"
      radius="full"
      size="lg"
      className="justify-center bg-white px-3 py-2"
      data-intercom-target="discovery-portal-overview-chip"
      tabIndex={0}
      aria-label={ariaLabel}
    >
      <Typography className="text-gray-900" variant="bodyMedium" as="span" fontWeight="semibold">
        {children}
      </Typography>
    </Chip>
  );
}

export default observer(ExperienceOverviewChip);
